import { roleStats } from "./accessors";
import { applyAoeHit } from "./combat";
import type { InfiniteWarState } from "./types";

export function tickDemigods(state: InfiniteWarState, step: number): void {
  for (const demigod of Object.values(state.demigods)) {
    demigod.attackCooldown = Math.max(0, demigod.attackCooldown - step);
    if (demigod.attackCooldown > 0) continue;
    const stats = roleStats(demigod.roleId);
    const aoe = (stats as { aoeRadius?: number }).aoeRadius ?? 80;
    const targets = state.units.filter(
      (unit) =>
        unit.phase === "alive" &&
        unit.team !== demigod.team &&
        Math.hypot(unit.x - demigod.x, unit.y - demigod.y) <= stats.range,
    );
    if (targets.length === 0) continue;
    demigod.attackCooldown = stats.attackSec;
    state.events.push({
      kind: "demigod_burst",
      team: demigod.team,
      x: demigod.x,
      y: demigod.y,
      radius: aoe,
    });
    for (const target of targets) {
      if (Math.hypot(target.x - demigod.x, target.y - demigod.y) > aoe) continue;
      applyAoeHit(state, target, stats.damage, demigod.team);
    }
  }
}
